// Use environment variable at build time to import only needed gateway
// Vite will tree-shake unused imports during build
const gatewayName = import.meta.env.VITE_API_GATEWAY;

let gateway;

if (gatewayName === 'S3BasedAPIGateway') {
  const module = await import('api/gateways/S3BasedAPIGateway');
  gateway = module.default;
} else {
  const module = await import('api/gateways/TransparentAPIGateway');
  gateway = module.default;
}

export default gateway;
